// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav-sF0VUnDj","li_checked":"li_checked-3pPTyDSM","span_checked":"span_checked-1rdEcKE9"};